import React from 'react'
import { useDragSort } from '@ztechapps/webui.util'
import { ActualRow } from './ActualRow'
import styles from './RowSortable.module.scss'
import type { TableProps } from './index'

export const RowSortable = ({ onDragSort, dataArray, ...props }: TableProps) => {
  const { getItemProps, getHandleProps, getContainerProps, dragState } = useDragSort({
    items: dataArray ?? [],
    getItemKey: (row, i) => row?._id ?? String(i),
    onSort: (event) => onDragSort?.(event),
  })

  // While a drag handler is not supplied, render a plain tbody.
  if (!onDragSort) {
    return (
      <tbody>
        <ActualRow {...{ dataArray, ...props }} />
      </tbody>
    )
  }

  return (
    <tbody {...getContainerProps()}>
      <ActualRow
        {...{ dataArray, ...props }}
        getItemProps={getItemProps}
        getHandleProps={getHandleProps}
        dragRowClassName={styles.rowSortable}
      />
      {/* Thin trailing drop zone (8px) rendered only during a drag.
          Gives the user a small overshoot buffer below the last row so
          drops that miss by a few pixels still land in the tbody's
          `getContainerProps()` handler and map to "append to end". */}
      {dragState.isDragging && (
        <tr aria-hidden="true" className={styles.trailingDropZone}>
          <td colSpan={100} />
        </tr>
      )}
    </tbody>
  )
}
